module.exports = __webpack_public_path__ + "img/20200416141836226.8cc7e8a1.png";